<ng-container #productGridItemContainer></ng-container>

<ng-template #DSTV2Template>
        <div class="product-card-container">
            <div class="{{'product-item-'+product.id}}" (click)="setProductDetails();">
                <ng-container *ngIf="pastPurchased">
                    <div data-qa="bia_bdg" class="buy-it-again__badge">Buy it Again</div>
                </ng-container>
                <div class="product-card-container__image-container mt-3" [ngClass]="{'has-tooltip' : product?.fullName?.length > 60 }">
                    <a (click)="setPfmDetailProduct(); sendAdIdClickEvent(); onProductClicked();"
                        id="{{'pg' + product.id + 'Img'}}" attr.data-bpn="{{ product.id }}" [attr.href]="getProductDetailPath()"
                        tabindex="-1">
                        <picture class="{{bgImgOpaque}}">
                            <source media="(max-width: {{sm}})" srcset="{{getImageUrl(product.id, 'mobile')}}">
                            <source media="(max-width: {{md}})" srcset="{{getImageUrl(product.id, 'tablet')}}">
                            <img loading="lazy" class="product-card-container__product-image" src="{{getImageUrl(product.id, 'desktop')}}"
                                alt="{{ product.name }}" data-qa="prd-itm-img" />
                        </picture>
                    </a>
                    <div *ngIf="product?.fullName?.length > 60" class="product-item-image-tooltip">
                        <div class="product-item-image-tooltip__arrow"></div>
                        <div class="product-item-image-tooltip__inner">{{product.fullName}}</div>
                    </div>
                </div>

                <div class="d-flex justify-content-start flex-row align-items-end">
                    <ng-container *ngIf="product.snapEligible">
                        <div class="product-card-container__snap product-card-container__snap--details word-highlight-xs "
                             [ngClass]="{'mb-3' : product.displayEstimateText }">
                            <span>SNAP</span>
                        </div>
                    </ng-container>
                    <ng-container *ngIf="product.displayEstimateText">
                    <span class="body-text-xxs">
                            {{product.displayEstimateText}}
                    </span>
                    </ng-container>
                    <ng-container *ngIf="showPCReview(product)">
                        <!-- Product Rating -->
                        <span class="d-flex ml-auto">
                        <span class="svg-star-icon" title="customer review star"></span>
                        <!-- // DFTA - commented out reviews for now for right-drawer -->
                        <!-- <span class="star-rating" tabindex="0" attr.aria-label="Rating {{product?.productReview?.avgRating}} out of 5">{{product?.productReview?.avgRating}}</span> -->
                    </span>
                    </ng-container>
                </div>

                <ng-container *ngIf="itemAvailable">
                     <!-- Product Price -->
                    <div class="product-card-container__details">
                        <div class="product-price">
                            <span id="{{'pg' + product.id + 'price'}}" class="product-price__saleprice product-price__discounted-price"
                            data-qa="prd-itm-prc"> <span class="sr-only">Your Price</span>
                            {{ validPrice | currency: 'USD' }}
                                <span *ngIf="(product.displayUnitQuantityText || isLBProduct()) && product.averageWeight === 1" aria-hidden="true" data-qa="qty-txt"> /
                                    {{ isLBProduct() ? (product.unitQuantity | lowercase) : product.displayUnitQuantityText}}</span>
                                <span *ngIf="(product.displayUnitQuantityText || isLBProduct()) && product.averageWeight < 1 && product.averageWeight > 0" aria-hidden="true" data-qa="qty-txt"> /
                                    {{ product.averageWeightStr }}
                                    {{ isLBProduct() ? (product.unitQuantity | lowercase) : product.displayUnitQuantityText}}</span>
                                <span class="sr-only" data-qa="each-or-lb">{{isLBProduct() ? 'lb' : 'each'}}</span>
                            </span>
                            <del class="product-price__baseprice" *ngIf="product.showStrikeThrough" data-qa="prd-itm-prc-del">
                                <span class="sr-only">Original Price</span>
                                {{product.basePrice | currency: 'USD' }}
                            </del>
                        </div>
                    </div>
                </ng-container>

                <!-- Product Title -->
                <div class="product-title">
                    <div class="product-title__text" [ngClass]="{'has-tooltip' : product?.fullName?.length > 60}">
                        <a (click)="setPfmDetailProduct(); sendAdIdClickEvent(); onProductClicked();" id="{{'pg' + product.id}}" attr.data-bpn="{{ product.id }}"
                        class="product-title__name" [attr.href]="getProductDetailPath()" data-qa="prd-itm-pttl" >{{ product.name }}</a>
                        <div *ngIf="product?.fullName?.length > 60" class="product-item-title-tooltip">
                            <div class="product-item-title-tooltip__arrow"></div>
                            <div class="product-item-title-tooltip__inner">{{product.fullName}}</div>
                        </div>
                    </div>

                    <div class="product-title__details" *ngIf="itemAvailable">
                        <div class="product-title__qty" id="{{'pg' + product.id + 'unitPer'}}" data-qa="prd-itm-pprc-qty" *ngIf="!isLBProduct()">
                            <span aria-hidden="true">({{ product.pricePer | currency: 'USD' }} / {{ product.unitQuantity | titlecase}})</span>
                            <span class="sr-only">({{ product.pricePer | currency: 'USD' }} per {{ product.unitQuantity | titlecase}})</span>
                        </div>
                        <ng-container *ngIf="sponsoredProduct">
                            <div class="product-title__right-text" data-qa="prd-itm-spnsrd">Sponsored</div>
                        </ng-container>
                    </div>

                    <ng-template #DSTV2DefaultOOS>
                        <!--Item not available-->
                        <div class="item-not-available" [ngClass]="isAnyProductHasAddlInfo ? 'item-not-available--with-addl-info' : 'item-not-available--with-out-ar'" *ngIf="!itemAvailable">
                            <div class="item-not-available__message">
                                <span aria-hidden="true" class="item-not-available__message__close-btn svg-x-outline-product-card"></span>
                                <span class="sr-only">Sorry</span>
                                <div data-qa="prd-itm-oos" class="item-not-available__message__text">
                                    <span class="sr-only">{{ product.name }}</span>
                                    {{ product['itemNotAvailableTxt'] }}
                                </div>
                            </div>
                            <a title="{{product.name}}" class="item-not-available__view-similar-items" data-qa="prd-itm-vw-smlr-itms" href="/bin/safeway/product/similar?aisleId={{ product.aisleId }}" (click)="analyticsSimilarItemsCTA()">View similar items</a>
                        </div>

                        <!-- Product available In-Store -->
                        <ng-container *ngIf="itemAvailable && !product['disableInStoreUICheck']">
                            <p class="product-card-container__instore-only">
                                This item is only available in-store.
                            </p>
                        </ng-container>

                        <!-- Unattended overlay -->
                        <div class="item-not-available" [ngClass]="isAnyProductHasAddlInfo ? 'item-not-available--with-addl-info' : 'item-not-available--with-out-ar'" *ngIf="(unAttendDeliveryFlag && product.restrictedValue > 0) && !itemAvailable">
                            <span>Available only with Attended Delivery</span>
                        </div>

                        <p id="pg{{product.id}}" class="product-card-container__mto-message" [ngClass]="isAnyProductHasAddlInfo ? 'product-card-container__mto-message--with-ar' : ''"  *ngIf="product.isMtoProduct && product.mtoText" data-qa="qty-stppr-mto">
                            {{ product.mtoText }}
                        </p>
                    </ng-template>

                    <ng-container *ngIf="enableOOSReDesign; else DSTV2DefaultOOS">
                        <!-- OOS Redesign -->
                        <div class="item-not-available" [ngClass]="isAnyProductHasAddlInfo ? 'item-not-available--with-addl-info' : 'item-not-available--with-out-ar'"  *ngIf="!itemAvailable">
                            <div>
                                <button (click)="viewSimilarClick()" class="btn btn-secondary bia-oos-font btn-md mt-3 totalWidth">View Similar</button>
                            </div>
                        </div>

                        <div class="product-card-container__labels" *ngIf="!itemAvailable">
                              <span class="sr-only">{{ product.name }}</span>
                              <span> {{ product['itemNotAvailableTxt'] }} </span>
                        </div>

                        <!-- Product available In-Store -->
                        <ng-container *ngIf="itemAvailable && !product['disableInStoreUICheck']">
                            <p class="product-card-container__instore-only">
                                This item is only available in-store.
                            </p>
                        </ng-container>

                        <!-- Unattended overlay -->
                        <div class="item-not-available" [ngClass]="isAnyProductHasAddlInfo ? 'item-not-available--with-addl-info' : 'item-not-available--with-out-ar'" *ngIf="(unAttendDeliveryFlag && product.restrictedValue > 0) && !itemAvailable">
                            <span>Available only with Attended Delivery</span>
                        </div>

                        <p id="pg{{product.id}}" class="product-card-container__mto-message" [ngClass]="isAnyProductHasAddlInfo ? 'product-card-container__mto-message--with-ar' : ''"  *ngIf="product.isMtoProduct && product.mtoText" data-qa="qty-stppr-mto">
                            {{ product.mtoText }}
                        </p>
                    </ng-container>

                    <!-- Product Coupon -->
                    <ng-container *ngIf="productCouponV2Visible">

                        <!-- // DFTA - commented out product coupons for right drawer -->
                        <!-- <product-coupon-v3
                            [product]="product"
                            (productCouponDetails)="onProductCouponDetailsChange($event)"
                            [couponCalledBy]="calledBy"
                            [showDetailsLink]="!isScheduleAndSaveCard()">
                        </product-coupon-v3> -->

                    </ng-container>
                </div>

                <!-- Quantity Stepper-->
                <ng-container *ngIf="itemAvailable && product['disableInStoreUICheck'] && (!unAttendDeliveryFlag || product.restrictedValue === 0) && !isLBProduct()">
                    <quantity-stepper-al-v1 id="pg{{product.id}}-qty"
                        [product]="product" [isAnyProductHasAddlInfo]="isAnyProductHasAddlInfo"
                        (removePastPurchasesEmitter)="onRemovedItem($event)"
                        [crossSellEnabled]='crossSell'
                        [crossSellType]='crossSellType'
                        [calledBy]="stepperCalledBy"
                        [configObj]="configObj">
                    </quantity-stepper-al-v1>
                 </ng-container>

                <ng-container *ngIf="itemAvailable && product['disableInStoreUICheck'] && (!unAttendDeliveryFlag || product.restrictedValue === 0) && isLBProduct()">
                    <quantity-dropdown-al-v1 [product]='product' [isAnyProductHasAddlInfo]="isAnyProductHasAddlInfo" [noWeightModal]="true">
                    </quantity-dropdown-al-v1> 
                </ng-container>

                <!-- // DFTA - commented out schedule and save for right drawer -->
                <!-- Schedule and Save-->
                <!-- <ng-container *ngIf="product['disableInStoreUICheck'] && (!unAttendDeliveryFlag || product.restrictedValue === 0)">
                    <auto-replenishment-v2 *ngIf="showArSubscription()" [product]="product"
                        [productDetailPath]="productDetailPath" (setDetailProduct)="setPfmDetailProduct()"
                        [calledBy]="'product-grid-item'">
                    </auto-replenishment-v2>
                </ng-container> -->

            </div>
                <!-- Sold & Shipped by -->
                <ng-container *ngIf="product.sellerId && product.sellerName">
                    <div class="product-card-container__seller">
                        <div class="body-text-xxs">Sold &amp; shipped by</div>
                        <a class="link-xxs product-card-container__seller__name"
                           [attr.href]="sellerLandingPath">{{product.sellerName}}</a>
                    </div>
                </ng-container>
        </div>
</ng-template>

<ng-template #genericProductCardTemplate>
    <div class="product-card-container" [ngClass]="isAnyProductHasAddlInfo === true ? 'product-card-container--with-addl-info' : 'product-card-container--without-ar'">
        <div class="{{'product-item-'+product.id}}" (click)="setProductDetails();">
            <ng-container *ngIf="displayableElements?.buyItAgain">
                <ng-container *ngIf="pastPurchased">
                    <div data-qa="bia_bdg" class="buy-it-again__badge">Buy it Again</div>
                </ng-container>
            </ng-container>

            <ng-container *ngIf="displayableElements?.image">
                <div class="product-card-container__image-container mt-3" [ngClass]="{'has-tooltip' : product?.fullName?.length > 60 }">
                    <a *ngIf="configObj?.programType !== '1P_SNS'" (click)="setPfmDetailProduct(); sendAdIdClickEvent(); onProductClicked();"
                        id="{{'pg' + product.id + 'Img'}}" attr.data-bpn="{{ product.id }}" [attr.href]="getProductDetailPath()"
                        tabindex="-1">
                        <picture class="{{bgImgOpaque}}">
                            <source media="(max-width: {{sm}})" srcset="{{getImageUrl(product.id, 'mobile')}}">
                            <source media="(max-width: {{md}})" srcset="{{getImageUrl(product.id, 'mobile')}}">
                            <img class="ab-lazy product-card-container__product-image" src="{{getImageUrl(product.id,'desktop')}}"
                                alt="{{ product.name }}" data-qa="prd-itm-img" />
                        </picture>
                    </a>
                    <div *ngIf="configObj?.programType === '1P_SNS'" id="{{'pg' + product.id + 'Img'}}" attr.data-bpn="{{ product.id }}">
                        <picture class="{{bgImgOpaque}}">
                            <source media="(max-width: {{sm}})" [attr.data-srcset]="getImageUrl(product.id,'mobile')">
                            <source media="(max-width: {{md}})" [attr.data-srcset]="getImageUrl(product.id,'tablet')">
                            <img class="ab-lazy product-card-container__product-image" [attr.data-src]="getImageUrl(product.id,'desktop')"
                                alt="{{ product.name }}" data-qa="prd-itm-img" />
                        </picture>
                    </div>
                    <ng-container *ngIf="displayableElements?.title">
                        <div *ngIf="product?.fullName?.length > 60" class="product-item-image-tooltip">
                            <div class="product-item-image-tooltip__arrow"></div>
                            <div class="product-item-image-tooltip__inner">{{product.fullName}}</div>
                        </div>
                    </ng-container>
                </div>
            </ng-container>

            <div class="d-flex justify-content-start flex-row align-items-end">
                <ng-container *ngIf="displayableElements.snapEligible && product.snapEligible">
                    <div id="snapLabel" class="product-card-container__snap product-card-container__snap--details word-highlight-xs "
                         [ngClass]="{'mb-3' : displayableElements?.estimateLabel && itemAvailable && !isLBProduct() && (validPrice > 0.00 && product.displayEstimateText) }">
                        <span>SNAP</span>
                    </div>
                </ng-container>
                <ng-container *ngIf="displayableElements?.estimateLabel">
                    <span *ngIf="itemAvailable && !isLBProduct() && (validPrice > 0.00 && product.displayEstimateText)"
                          class="body-text-xxs">
                            {{product.displayEstimateText}}
                    </span>
                </ng-container>
                <ng-container *ngIf="displayableElements?.starRating">
                    <!-- Product Rating -->
                    <span class="d-flex ml-auto" *ngIf="showPCReview(product)">
                        <span class="svg-star-icon" title="customer review star"></span>
                        <span class="star-rating" aria-hidden="true">{{product?.productReview?.avgRating}}</span>
                        <span class="sr-only">Rating {{product?.productReview?.avgRating}} out of 5 stars</span>
                    </span>
                </ng-container>
            </div>
            
            <ng-container *ngIf="displayableElements?.price">
                <ng-container *ngIf="itemAvailable">
                    <!-- Product Price -->
                    <div class="product-card-container__details">
                        <div class="product-price">
                            <span id="{{'pg' + product.id + 'price'}}" class="product-price__saleprice product-price__discounted-price"
                            data-qa="prd-itm-prc"> <span class="sr-only">Your Price</span>
                            {{ validPrice | currency: 'USD' }}
                                <span *ngIf="(product.displayUnitQuantityText || isLBProduct()) && product.averageWeight === 1" aria-hidden="true" data-qa="qty-txt"> /
                                    {{ isLBProduct() ? (product.unitQuantity | lowercase) : product.displayUnitQuantityText}}</span>
                                <span *ngIf="(product.displayUnitQuantityText || isLBProduct()) && product.averageWeight < 1 && product.averageWeight > 0" aria-hidden="true" data-qa="qty-txt"> /
                                    {{ product.averageWeightStr }}
                                    {{ isLBProduct() ? (product.unitQuantity | lowercase) : product.displayUnitQuantityText}}</span>
                                <span class="sr-only" data-qa="each-or-lb">{{isLBProduct() ? 'lb' : 'each'}}</span>
                            </span>
                            <del class="product-price__baseprice" *ngIf="product.showStrikeThrough" data-qa="prd-itm-prc-del">
                                <span class="sr-only">Original Price</span>
                                {{product.basePrice | currency: 'USD' }}
                            </del>
                        </div>
                    </div>
                </ng-container>
            </ng-container>

            <!-- Product Title -->
            <ng-container *ngIf="displayableElements?.title">
                <div class="product-title" [ngClass]="{'product-title--disabled':configObj?.programType === '1P_SNS'}">
                    <div class="product-title__text" [ngClass]="{'has-tooltip' : product?.fullName?.length > 60 }">
                        <a *ngIf="configObj?.programType !== '1P_SNS'" (click)="setPfmDetailProduct(); sendAdIdClickEvent(); onProductClicked();" id="{{'pg' + product.id}}" attr.data-bpn="{{ product.id }}"
                        class="product-title__name" [attr.href]="getProductDetailPath()" data-qa="prd-itm-pttl">
                            {{ product.name }}
                        </a>
                        <span *ngIf="configObj?.programType === '1P_SNS'" class="product-title__name" id="{{'pg' + product.id}}" attr.data-bpn="{{ product.id }}" data-qa="prd-itm-pttl">
                            {{ product.name }}
                        </span>
                        <div *ngIf="product?.fullName?.length > 60" class="product-item-title-tooltip">
                            <div class="product-item-title-tooltip__arrow"></div>
                            <div class="product-item-title-tooltip__inner">{{product.fullName}}</div>
                        </div>
                    </div>

                    <div class="product-title__details" *ngIf="itemAvailable">
                        <div class="product-title__qty" id="{{'pg' + product.id + 'unitPer'}}" data-qa="prd-itm-pprc-qty" *ngIf="!isLBProduct()">
                            <span aria-hidden="true">({{ product.pricePer | currency: 'USD' }} / {{ product.unitQuantity | titlecase}})</span>
                            <span class="sr-only">({{ product.pricePer | currency: 'USD' }} per {{ product.unitQuantity | titlecase}})</span>
                        </div>
                        <ng-container *ngIf="displayableElements?.sponsoredLabel">
                            <ng-container *ngIf="sponsoredProduct">
                                <div class="product-title__right-text" data-qa="prd-itm-spnsrd">Sponsored</div>
                            </ng-container>
                        </ng-container>
                    </div>

                    <ng-container *ngIf="enableOOSReDesign; else GenericDefaultOOS">
                        <!-- OOS Redesign -->
                        <div class="item-not-available" [ngClass]="isAnyProductHasAddlInfo ? 'item-not-available--with-addl-info' : 'item-not-available--with-out-ar'"  *ngIf="!itemAvailable && configObj?.programType !== '1P_SNS'">
                            <div>
                                <button (click)="viewSimilarClick()" class="btn btn-secondary bia-oos-font btn-md mt-3 totalWidth">View Similar</button>
                            </div>
                        </div>

                        <div class="product-card-container__labels" *ngIf="!itemAvailable">
                            <span class="sr-only">{{ product.name + ' ' + product['itemNotAvailableTxt'] }}</span>
                            <span aria-hidden="true">{{ product['itemNotAvailableTxt'] }}</span>
                        </div>

                        <!-- Product available In-Store -->
                        <ng-container *ngIf="itemAvailable && !product['disableInStoreUICheck']">
                            <p class="product-card-container__instore-only">
                                This item is only available in-store.
                            </p>
                        </ng-container>

                        <!-- Unattended overlay -->
                        <ng-container *ngIf="displayableElements?.unattendedDeliveryLabel">
                            <div class="item-not-available" [ngClass]="isAnyProductHasAddlInfo ? 'item-not-available--with-addl-info' : 'item-not-available--with-out-ar'" *ngIf="(unAttendDeliveryFlag && product.restrictedValue > 0) && !itemAvailable">
                                <span>Available only with Attended Delivery</span>
                            </div>
                        </ng-container>
                       
                        <ng-container *ngIf="displayableElements?.mto">
                            <p id="pg{{product.id}}" class="product-card-container__mto-message" [ngClass]="isAnyProductHasAddlInfo ? 'product-card-container__mto-message--with-ar' : ''"  *ngIf="product.isMtoProduct && product.mtoText" data-qa="qty-stppr-mto">
                                {{ product.mtoText }}
                            </p> 
                        </ng-container>
                        
                    </ng-container>
                    
                    <ng-template #GenericDefaultOOS>
                         <!--Item not available-->
                        <ng-container *ngIf="displayableElements?.title">                
                            <div class="item-not-available" [ngClass]="isAnyProductHasAddlInfo ? 'item-not-available--with-addl-info' : 'item-not-available--with-out-ar'" *ngIf="!itemAvailable">
                                <div class="item-not-available__message">
                                    <span aria-hidden="true" class="item-not-available__message__close-btn svg-x-outline-product-card"></span>
                                    <span class="sr-only">Sorry</span>
                                    <div data-qa="prd-itm-oos" class="item-not-available__message__text">
                                        <span class="sr-only">{{ product.name }}</span>
                                        {{ product['itemNotAvailableTxt'] }}
                                    </div>
                                </div>
                                <ng-container *ngIf="displayableElements?.viewSimilarItemsLink && configObj?.programType !== '1P_SNS'">
                                    <a title="{{product.name}}" class="item-not-available__view-similar-items" data-qa="prd-itm-vw-smlr-itms" href="/bin/safeway/product/similar?aisleId={{ product.aisleId }}" (click)="analyticsSimilarItemsCTA()">View similar items</a>
                                </ng-container>
                            </div>
                        </ng-container>


                        <!-- Product available In-Store -->
                        <ng-container *ngIf="displayableElements?.availableInStoreLabel">
                            <ng-container *ngIf="itemAvailable && !product['disableInStoreUICheck']">
                                <p class="product-card-container__instore-only">
                                    This item is only available in-store.
                                </p>
                            </ng-container>
                        </ng-container>

                        <!-- Unattended overlay -->
                        <ng-container *ngIf="displayableElements?.unattendedDeliveryLabel">
                            <div class="item-not-available" [ngClass]="isAnyProductHasAddlInfo ? 'item-not-available--with-addl-info' : 'item-not-available--with-out-ar'" *ngIf="(unAttendDeliveryFlag && product.restrictedValue > 0) && !itemAvailable">
                                <span>Available only with Attended Delivery</span>
                            </div>
                        </ng-container>

                        <ng-container *ngIf="displayableElements?.mto">
                            <p id="pg{{product.id}}" class="product-card-container__mto-message" [ngClass]="isAnyProductHasAddlInfo ? 'product-card-container__mto-message--with-ar' : ''"  *ngIf="product.isMtoProduct && product.mtoText" data-qa="qty-stppr-mto">
                                {{ product.mtoText }}
                            </p>
                        </ng-container>
                    </ng-template>

                    <!-- Product Coupon -->
                    <ng-container *ngIf="displayableElements?.coupons && configObj.programType !== '1P_SNS'">
                        <ng-container *ngIf="productCouponV2Visible">
                            <product-coupon-al-v1
                                [product]="product"
                                (productCouponDetails)="onProductCouponDetailsChange($event)"
                                [couponCalledBy]="calledBy"
                                [showDetailsLink]="!isScheduleAndSaveCard()"
                                [productOffers] = "productOffers"
                                [configObj]="configObj">
                            </product-coupon-al-v1>
                        </ng-container>
                    </ng-container>
                </div>
            </ng-container>
            <!-- Quantity Stepper-->
            <ng-container *ngIf="displayableElements?.addToCart">
                <ng-container *ngIf="itemAvailable && product['disableInStoreUICheck'] && (!unAttendDeliveryFlag || product.restrictedValue === 0) && !isLBProduct()">
                    <ng-container *ngIf="calledBy === 'buy-it-again-qsc'; else defaultStepper">
                        <div class="qsc-product-card__selector-container" [ngClass]="isAnyProductHasAddlInfo ? 'qsc-product-card__selector-container__with-ar' : 'qsc-product-card__selector-container__with-out-ar'">
                            <div class="checkbox" [ngClass]="{'show' : isCheckboxChecked}">
                                <label class="checkbox__group" for="pg{{product.id}}-chk" aria-label="Checkbox">
                                    <input class="checkbox__input" type="checkbox"
                                        [attr.aria-checked]="isCheckboxChecked" id="pg{{product.id}}-chk" (keydown.enter)="onCheckboxClick($event)" (click)="onCheckboxClick($event)">
                                    <span class="checkbox__checkmark qsc-checkbox__checkmark"><span
                                            class="svg-checkmark"></span></span>
                                </label>
                            </div>
                            <quantity-stepper-al-v1 [ngClass]="{'qsc-qty-stepper-v3': true}" id="pg{{product.id}}-qty"
                                [product]="product" [isAnyProductHasAddlInfo]="isAnyProductHasAddlInfo"
                                (removePastPurchasesEmitter)="onRemovedItem($event)"
                                [crossSellEnabled]='crossSell'
                                [crossSellType]='crossSellType'
                                [calledBy]="stepperCalledBy"
                                [configObj]="configObj"
                                [isQscV2]="true"
                                [isCheckboxChecked] = "isCheckboxChecked"
                                (updateCheckboxEmitter) = "onCheckboxClick()">
                            </quantity-stepper-al-v1>
                        </div>
                    </ng-container>
                    <ng-template #defaultStepper>
                        <quantity-stepper-al-v1 id="pg{{product.id}}-qty"
                            [product]="product" [isAnyProductHasAddlInfo]="isAnyProductHasAddlInfo"
                            (removePastPurchasesEmitter)="onRemovedItem($event)"
                            [crossSellEnabled]='crossSell'
                            [crossSellType]='crossSellType'
                            [calledBy]="stepperCalledBy"
                            [configObj]="configObj">
                        </quantity-stepper-al-v1>
                    </ng-template>
                    
                </ng-container>
            </ng-container>

            <ng-container *ngIf="displayableElements.addToCart">
                <ng-container *ngIf="itemAvailable && product['disableInStoreUICheck'] && (!unAttendDeliveryFlag || product.restrictedValue === 0) && isLBProduct()">
                    <ng-container *ngIf="calledBy === 'buy-it-again-qsc'; else defaultDropdown">
                        <div class="qsc-product-card__selector-container" [ngClass]="isAnyProductHasAddlInfo ? 'qsc-product-card__selector-container__with-ar' : 'qsc-product-card__selector-container__with-out-ar'">
                            <div class="checkbox" [ngClass]="{'show' : isCheckboxChecked}">
                                <label class="checkbox__group" for="pg{{product.id}}-chk" aria-label="Checkbox">
                                    <input class="checkbox__input" type="checkbox" checked="isCheckboxChecked"
                                        aria-checked="true" id="pg{{product.id}}-chk" (click)="onCheckboxClick($event)">
                                    <span class="checkbox__checkmark qsc-checkbox__checkmark"><span
                                            class="svg-checkmark"></span></span>
                                </label>
                            </div>
                            <quantity-dropdown-al-v1 [ngClass]="{'qsc-dropdown-v2' : true}" [product]='product'
                                [isAnyProductHasAddlInfo]="isAnyProductHasAddlInfo" [isQscV2]="true"
                                [isCheckboxChecked]="isCheckboxChecked" (updateCheckboxEmitter)="onCheckboxClick()"
                                [configObj]="configObj">
                            </quantity-dropdown-al-v1>
                        </div>
                    </ng-container>

                    <ng-template #defaultDropdown>
                        <quantity-dropdown-al-v1 [product]='product' [isAnyProductHasAddlInfo]="isAnyProductHasAddlInfo" [configObj]="configObj">
                        </quantity-dropdown-al-v1>
                    </ng-template>

                </ng-container>
            </ng-container>
            <!-- Schedule and Save-->
            <ng-container *ngIf="displayableElements?.scheduleNSave">
                <ng-container *ngIf="product['disableInStoreUICheck'] && (!unAttendDeliveryFlag || product.restrictedValue === 0)">
                    <auto-replenishment-al-v1 *ngIf="showArSubscription()" [product]="product"
                        [productDetailPath]="productDetailPath" (setDetailProduct)="setPfmDetailProduct()"
                        [calledBy]="'product-grid-item'" [isBiaLandingPage]="enableOOSReDesign">
                    </auto-replenishment-al-v1>
                </ng-container>
            </ng-container>
            <!-- Sold & Shipped by -->
            <ng-container *ngIf="displayableElements?.sellerTag && product.sellerId && product.sellerName">
                <div class="product-card-container__seller">
                    <div class="body-text-xxs">Sold &amp; shipped by</div>
                    <a class="link-xxs product-card-container__seller__name"
                       [attr.href]="sellerLandingPath">{{product.sellerName}}</a>
                </div>
            </ng-container>
        </div>
    </div>
</ng-template>

